import { createFileRoute } from '@tanstack/react-router';
import { TruckTemplatesPage } from '@/features/inventory/TruckTemplatesPage';
export const Route = createFileRoute('/_dashboard/dashboard/inventory/truck-templates')({
  component: TruckTemplatesPage,
});
